import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Payment\CheckChequeNumberAvailabilityController::__invoke
* @see app/Http/Controllers/Payment/CheckChequeNumberAvailabilityController.php
* @route '/api/payment/cheque-number-availability'
*/
const CheckChequeNumberAvailabilityController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckChequeNumberAvailabilityController.url(options),
    method: 'get',
})

CheckChequeNumberAvailabilityController.definition = {
    methods: ["get","head"],
    url: '/api/payment/cheque-number-availability',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Payment\CheckChequeNumberAvailabilityController::__invoke
* @see app/Http/Controllers/Payment/CheckChequeNumberAvailabilityController.php
* @route '/api/payment/cheque-number-availability'
*/
CheckChequeNumberAvailabilityController.url = (options?: RouteQueryOptions) => {
    return CheckChequeNumberAvailabilityController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Payment\CheckChequeNumberAvailabilityController::__invoke
* @see app/Http/Controllers/Payment/CheckChequeNumberAvailabilityController.php
* @route '/api/payment/cheque-number-availability'
*/
CheckChequeNumberAvailabilityController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckChequeNumberAvailabilityController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Payment\CheckChequeNumberAvailabilityController::__invoke
* @see app/Http/Controllers/Payment/CheckChequeNumberAvailabilityController.php
* @route '/api/payment/cheque-number-availability'
*/
CheckChequeNumberAvailabilityController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CheckChequeNumberAvailabilityController.url(options),
    method: 'head',
})

export default CheckChequeNumberAvailabilityController